var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isYoutube && _vm.youtubePreview)?_c('div',[_c('YoutubePlayer',{attrs:{"video-id":_vm.linkInfo.videoId,"start":_vm.linkInfo.start}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_vm._t("default")],2)],1):(_vm.isLihkg)?_c('LIHKGPreview',{attrs:{"thread-id":_vm.linkInfo.threadId,"href":_vm.href}}):_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23d67d6f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thread/Message/Anchor.vue
// module id = 686
// module chunks = 1